import styled from 'styled-components';

import { BadgeStyled } from 'approot/shared/badge/badge.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { spacing12 } from 'approot/shared/styles/spacing.style';

export const Attribution = styled(BadgeStyled).attrs({
  $colour: grey1,
})`
  display: inline-flex;
  align-items: center;
  padding-top: ${rem(spacing12)};
  padding-bottom: ${rem(spacing12)};
`;
